import { render } from "./Permission.vue?vue&type=template&id=1ed5d5ce&scoped=true&ts=true"
import script from "./Permission.vue?vue&type=script&lang=ts"
export * from "./Permission.vue?vue&type=script&lang=ts"

import "./Permission.vue?vue&type=style&index=0&id=1ed5d5ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed5d5ce"]])

export default __exports__